const GET_REPUTATION_LEVEL = 'core/reputationLevel/GET_REPUTATION_LEVEL';
const GET_REPUTATION_LEVEL_COMPLETED = 'core/reputationLevel/GET_REPUTATION_LEVEL_COMPLETED';
const GET_REPUTATION_LEVEL_FAILED = 'core/reputationLevel/GET_REPUTATION_LEVEL_FAILED';

export { GET_REPUTATION_LEVEL, GET_REPUTATION_LEVEL_COMPLETED, GET_REPUTATION_LEVEL_FAILED };
